/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  dispatchErrorMsgCms,
  dispatchFrom,
  dispatchQuarterlyCms,
  getQuarterlyCms,
} from '../Store/action';
import {
  handleScrollToEvent,
  quarterTest1,
  quarterTest2,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  tabHighLigther,
  autoFormateDate,
} from '../../../../SharedModules/utilities/utilities';
import {
  STATUS_MSG,
  SUCCESS_MSG,
  QUARTER_VALUE_REQUIRED,
  VALIDATE_QUARTER_VALUE,
} from '../../../../SharedModules/Errors/constantMessageData';

import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const CmsDrug = (props) => {
  const dispatch = useDispatch();

  const {
    errorMsgCmsDrug: getErrorMsg,
    startQtr: getQuarter,
    quarterlyCms: getQuarterlyCmsDrugList,
  } = useSelector((state) => state?.sharedState?.QuarterlyCmsDrugReducer);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const [startQtr, setStartQtr] = React.useState(getQuarter);

  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  // on blur functionality on field level
  
// Clear the toast error
  React.useEffect(() => {
     dispatch(dispatchErrorMsgCms([]));
  }, [startQtr]);

  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value;
    if (type === 'startQtr') {
      value = autoFormateDate(data);
      if (data && !_.isEmpty(data) && !_.isNaN(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'startQtr',
              errorType: 'startQtrRequired',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'startQtr',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'startQtr');
          setStartQtr(value?.toUpperCase());
        } else {
          localErr = localErr.filter((item) => item.field !== 'startQtr');
          localErr.push({
            field: 'startQtr',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'startQtr');
        if (type === 'startQtr') {
          localErr.push({
            field: 'startQtr',
            errorType: 'startQtrRequired',
            message: QUARTER_VALUE_REQUIRED,
          });
        }
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgCms(unique));
  };
  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/cmsDrug', true);
    } else {
      tabHighLigther('/cmsDrug', false);
    }
  }, [JSON.stringify(getErrorMsg)]);
  // on Click to next screen
  const click = () => {
    let localErr = getErrorMsg || [];
    if (!startQtr) {
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'startQtr');
      localErr.push({
        field: 'startQtr',
        errorType: 'required',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgCms(unique));
    if (localErr.length == 0) {
      function getQuarterDates(quarter) {
        const quarterNum = parseInt(quarter.slice(0, 1))+1;
        if(quarterNum==5){
          var  year = parseInt(quarter?.slice(-4))+1;
        }
        else
        {
          var year = parseInt(quarter?.slice(-4));
        }
        let startDate;
        let endDate;

        switch (quarterNum) {
          case 1:
            startDate = new Date(year, 0, 1);
            endDate = new Date(year, 2, 31);
            break;
          case 2:
            startDate = new Date(year, 3, 1);
            endDate = new Date(year, 5, 30);
            break;
          case 3:
            startDate = new Date(year, 6, 1);
            endDate = new Date(year, 8, 30);
            break;
          case 4:
            startDate = new Date(year, 9, 1);
            endDate = new Date(year, 11, 31);
            break;
          case 5:
            startDate = new Date(year, 0, 1);
            endDate = new Date(year, 2, 31);
            break;
        }

        const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
        const startStr = startDate.toLocaleDateString('en-US', options);
        const endStr = endDate.toLocaleDateString('en-US', options);

        return { startDate: startStr, endDate: endStr };
      }
      const qtr = getQuarterDates(startQtr);
      dispatch(dispatchQuarterlyCms([]));
      setSearchClicked(true);
      dispatch(
        getQuarterlyCms({
          startDate: qtr.startDate,
          endDate: qtr.endDate,
        })
      );
      dispatch(dispatchFrom(startQtr));
    }
  };
  if (
    isSearchClicked &&
    getQuarterlyCmsDrugList?.quarterlyCmsDrugReportVO?.length > 0
  ) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/displayCmsDrug',
      value: 'Display Quarterly CMS Drug Report',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/displayCmsDrug',
    });
    dispatch(clearReduxForFilterAndSort('/displayCmsDrug'));
  }

  const handlefromChange = (event) => {
    let { value } = event.target;

    if (value.includes('q')) {
      value = value.replace('q', 'Q');
    }

    setStartQtr(value);

    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'startQtr');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgCms(unique));
  };
  return (
    <div className="tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="State Reports" parent2="Quarterly CMS Drug" />
      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            getErrorMsg?.length > 0 ? _.map(getErrorMsg, (l) => l.message) : []
          ),
        ]}
      />
      <div className="tab-body">
        <div className="col-4">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">
              Quarter<span className="mandatory"> *</span>
            </legend>
            <div className="form-wrapper p-0">
              <div className="mui-custom-form with-select field-xl no-lbl">
                <TextField
                  id="check_by_invoice_quater"
                  label="check_by_invoice_quate"
                  data-testid="req-NDC-payment-quarter"
                  required
                  fullWidth
                  value={startQtr}
                  onChange={handlefromChange}
                  placeholder=""
                  inputProps={{ maxLength: 6 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field == 'startQtr' ? 'mandate-fields' : null
                        )
                      : null
                  }
                  onBlur={(e) => handleOnblurEvent('startQtr', e.target.value)}
                  helperText={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'startQtr' ? l.message : null
                        )
                      : null
                  }
                  error={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field == 'startQtr' ? l.message : null
                        )
                      : null
                  }
                />
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="col-sm-12">
        <div className="btn-wrapper mb-2">
          <div className="float-right mt-2 hide-on-print" tabIndex={0}>
            <Button
              className="btn btn-success btn-search"
              data-testid="view_detail_ia"
              type="button"
              onClick={click}
            >
              {' '}
              <SVGComponent iconName="Icon-search" /> {'  '} Search
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CmsDrug;
